import { render } from "./drafts.vue?vue&type=template&id=17434862"
import script from "./drafts.js?vue&type=script&lang=js"
export * from "./drafts.js?vue&type=script&lang=js"

import "./drafts.vue?vue&type=style&index=0&id=17434862&lang=scss"

import exportComponent from "/home/jojo/Documents/aspho-fe-pleromer/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__